<template>
  <div class="box">
    <div class="content">
      <el-form
        ref="formRef"
        label-width="120px"
        :rules="rules"
        :model="form"
        @submit.native.prevent
      >
        <el-form-item label="医生姓名" prop="username">
          <el-input
            v-model="form.username"
            maxlength="12"
            clearable
            placeholder="请输入姓名"
            style="width: 608px;"
          ></el-input>
        </el-form-item>
        <el-form-item label="绑定手机号" prop="phoneNo">
          <el-input
            v-model="form.phoneNo"
            clearable
            placeholder="请输入微信授权手机号"
            style="width: 608px;"
          ></el-input>
        </el-form-item>
        <el-form-item label="所属医院" prop="affiliatedHospital">
          <el-input
            v-model="form.affiliatedHospital"
            maxlength="24"
            clearable
            placeholder="请输入所属医院"
            style="width: 608px;"
          ></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="gender">
          <el-select
            style="width: 608px;"
            v-model="form.gender"
            clearable
            placeholder="请选择性别"
          >
            <el-option
              v-for="item in range"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!--        <el-form-item label="医生执业证号" prop="idCardNo">-->
        <!--          <el-input v-model="form.idCardNo" @change="idCardNoChange" clearable placeholder="请输入医生执业证号"></el-input>-->
        <!--        </el-form-item>-->
        <el-form-item label="医生执业证号" prop="idCardNo">
          <el-input
            v-model="form.idCardNo"
            clearable
            placeholder="请输入医生执业证号"
            style="width: 608px;"
          ></el-input>
        </el-form-item>
        <!--        <el-form-item label="年龄" prop="age">
          <el-input v-model="form.age" clearable placeholder="请输入年龄"></el-input>
        </el-form-item>-->

        <el-form-item label="">
          <div style="margin-left: 24px;color:#606266;font-size:14px'">
            <div>
              <div>AI回复肠道准备情况</div>
              <div class="my-4 flex items-center text-sm">
                <el-radio-group
                  v-model="form.isOpenAi"
                  class="ml-4"
                  @change="radioChange"
                >
                  <el-radio value="0" label="0" size="small">开启</el-radio>
                  <el-radio value="1" label="1" size="small">关闭</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div v-if="form.isOpenAi == 0">
              <div>AI回复是否需要确认</div>
              <div class="my-4 flex items-center text-sm">
                <el-radio-group v-model="form.checkType" class="ml-4">
                  <el-radio value="0" label="0" size="small">需要确认</el-radio>
                  <el-radio value="1" label="1" size="small"
                    >不需要确认</el-radio
                  >
                </el-radio-group>
              </div>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="医生端功能权限" prop="appletMenuIdsD">
          <el-tree
            :data="doctorTreeData"
            show-checkbox
            default-expand-all
            node-key="appletMenuId"
            ref="doctorTreeRef"
            :props="defaultProps"
            highlight-current
          >
          </el-tree>
        </el-form-item>
<!--        <el-form-item label="患者端功能权限" prop="appletMenuIdsP">
          <el-tree
            @check="nodeClick"
            :data="patientTreeData"
            show-checkbox
            default-expand-all
            node-key="appletMenuId"
            ref="patientTreeRef"
            :props="defaultProps"
            highlight-current
          >
          </el-tree>
        </el-form-item>-->
        <el-form-item>
          <el-button @click="onSubmit" type="primary" :loading="addLoading" >确认</el-button>
          <el-button @click="go_back">返回</el-button>
        </el-form-item>
        <el-form-item label-width="0" >
          <div class="line" :style="{width: '100%', border: '1px solid #DBDBDB'}" ></div>
        </el-form-item>
        <el-form-item label="分组管理">
          <el-button @click="addGroupingHandler" :disabled="!doctorID" class="AddGroupBtn" type="primary"
            >+添加分组</el-button
          >
          <div class="table-box">
            <el-table :data="tableData" style="width: 100%;">
              <el-table-column
                width="100"
                align="center"
                prop="status"
                label="当前状态"
              >
                <template slot-scope="scope">
                  <div>
                    <span :class="{ 'disable': tableDisable }" style="color: #00D319;" v-if="scope.row.status === 0">启动</span>
                    <span :class="{ 'disable': tableDisable }" style="color: red;" v-else>停用</span>
                  </div>
                </template>
              </el-table-column>
              <template v-if="doctorID" >
                <el-table-column
                    align="center"
                    prop="createTime"
                    label="创建时间"
                ></el-table-column>
              </template>
              <el-table-column
                align="center"
                prop="name"
                label="患者分组名称">
                <template #default="scope" >
                  <div>
                    <span :class="{ 'disable': tableDisable }">{{ scope.row.name }}</span>
                    <span :style="{color: '#c8c9cc'}" >{{ !scope.row.type ? '（默认分组）' : '' }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="leaderName"
                label="分组负责人">
                <template #default="scope" >
                  <span :class="{ 'disable': tableDisable }">{{ scope.row.leaderName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="groupList"
                label="分组成员">
                <template #default="scope" >
                  <span :class="{ 'disable': tableDisable }">{{ groupNames(scope.row.groupList) }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="medicalRecordRequired" label="就医档案">
                <template slot-scope="scope">
                  <span :class="{ 'disable': tableDisable }">{{ scope.row.medicalRecordRequired ? '必填':'非必填' }}</span>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="groupMenuIds"
                show-overflow-tooltip
                label="患者端功能权限"
                width="300">
                <template #default="scope" >
                  <span :class="{ 'disable': tableDisable }">{{ groupMenuNames(scope.row.groupMenuIds) }}</span>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="name"
                label="操作"
                width="300"
              >
                <template slot-scope="scope">
                  <div>
                    <div v-if="scope.row.isLeader === 1" class="operate-box">
                      <el-link
                      @click="ChangePersonClick(scope.row)"
                        :underline="false"
                        :disabled="tableDisable || !scope.row.type"
                        :type="tableDisable || !scope.row.type ? 'info' : 'primary'"
                        >更换负责人</el-link
                      >
                      <el-link
                      @click="QRgroup(scope.row)"
                        :underline="false"
                        :disabled="tableDisable || scope.row.status === 1"
                        :type="tableDisable || scope.row.status === 1 ? 'info' : 'primary'"
                        >入组二维码</el-link
                      >
                      <el-link @click="edit(scope.row)"
                               :underline="false"
                               :disabled="tableDisable"
                               :type="tableDisable ? 'info' : 'primary'"
                      >编辑</el-link>
                      <template v-if="scope.row.status" >
                        <el-link
                            :underline="false"
                            :disabled="tableDisable"
                            :type="tableDisable ? 'info' : 'primary'"
                            @click="Enable(scope.row)">启用</el-link>
                      </template>
                      <template v-else >
                        <!-- DeactivateDisabled -->
                        <el-link @click="DeactivateHandler(scope.row)"
                                 :underline="false"
                                 :disabled="tableDisable ||scope.row.DeactivateDisabled "
                                 :type="tableDisable ? 'info' : 'primary'">停用</el-link>
                      </template>

                      <el-link
                        @click="delGroupingHandler(scope.row)"
                        :disabled="tableDisable || !scope.row.type"
                        :type="tableDisable ? 'info' : 'primary'"
                        :underline="false"
                        >删除</el-link
                      >
                    </div>
                    <div v-else class="operate-box" >
                      <el-link
                          @click="QRgroup(scope.row)"
                          :underline="false"
                          :disabled="tableDisable || scope.row.status === 1"
                          :type="tableDisable || scope.row.status === 1 ? 'info' : 'primary'"
                      >入组二维码</el-link
                      >
                      <el-link
                          @click="withdrawClick(scope.row)"
                          :underline="false"
                          :disabled="tableDisable"
                          :type="tableDisable ? 'info' : 'primary'"
                      >退组</el-link>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <addGroupingDialog v-model="addGrouping.show" v-bind="addGrouping" :id="GroupingId" :doctorID="doctorID" @confirm="getList(doctorID)" ></addGroupingDialog>
    <delGroupingDialog v-model="delGrouping.show" v-bind="delGrouping" :doctorID="doctorID" @confirm="getList(doctorID)" ></delGroupingDialog>
    <withdrawDialog v-model="withdraw.show" v-bind="withdraw" :doctorID="doctorID" @confirm="getList(doctorID)" ></withdrawDialog>
    <ChangePersonDialog v-model="ChangePerson.show" v-bind="ChangePerson" :doctorID="doctorID" @confirm="getList(doctorID)" ></ChangePersonDialog>
    <deactivateDialog v-model="deactivate.show" v-bind="deactivate" :doctorID="doctorID" @confirm="getList(doctorID)" ></deactivateDialog>
    <groupCodeDialog v-model="groupCode.show" :image="groupCode.image" :title="groupCode.title" ></groupCodeDialog>
  </div>
</template>

<script>
import { IdCard } from "@/utils/IdCard";
import addGroupingDialog from "@/components/doctorManage/addGroupingDialog.vue";
import delGroupingDialog from "@/components/doctorManage/delGroupingDialog.vue";
import withdrawDialog from "@/components/doctorManage/withdrawDialog.vue";
import ChangePersonDialog from "@/components/doctorManage/ChangePersonDialog.vue";
import deactivateDialog from "@/components/doctorManage/deactivateDialog.vue";
import groupCodeDialog from "@/components/doctorManage/groupCodeDialog.vue";

export default {
  name: "doctorManageAdd",
  components:{
    addGroupingDialog,
    delGroupingDialog,
    withdrawDialog,
    ChangePersonDialog,
    deactivateDialog,
    groupCodeDialog,
  },
  data() {
    return {
      form: {
        id: "",
        username: "",
        phoneNo: "",
        idCardNo: "",
        affiliatedHospital: "",
        identity: "",
        gender: "",
        age: "",
        appletMenuIdsD: [],
        appletMenuIdsP: [],
        checkType: "0",
        isOpenAi: "0",
      },
      rules: {
        username: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          // { min: 0, max: 12, message: '姓名长度在 0 到 12 位', trigger: 'blur' }
        ],
        phoneNo: [
          { required: true, message: "请输入微信授权手机号", trigger: "blur" },
          {
            pattern: /^((13[0-9])|(14[0,1,4-9])|(15[0-3,5-9])|(16[2,5,6,7])|(17[0-8])|(18[0-9])|(19[0-3,5-9]))\d{8}$/,
            message: "手机号不正确",
          },
        ],
        idCardNo: [
          // { required: true, message: '请输入医生执业证号', trigger: 'blur' },
          // { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: "身份证号不合法" }
        ],
        affiliatedHospital: [
          { required: true, message: "请输入所属医院", trigger: "blur" },
          // { min: 0, max: 24, message: '姓名长度在 0 到 24 位', trigger: 'blur' }
        ],
        appletMenuIdsD: [
          { required: true, message: "请选择医生端功能权限", trigger: "blur" },
        ],
        appletMenuIdsP: [
          { required: true, message: "请选择患者端功能权限", trigger: "blur" },
        ],
        identity: [{ required: true, message: "请选择身份", trigger: "blur" }],
        gender: [{ required: true, message: "请选择性别", trigger: "blur" }],
        age: [{ required: true, message: "请输入年龄", trigger: "blur" }],
      },
      identity_list: [
        {
          value: "0",
          label: "全科医生",
        },
        {
          value: "1",
          label: "肠道医生",
        },
      ],
      range: [
        {
          value: "1",
          label: "男",
        },
        {
          value: "0",
          label: "女",
        },
      ],
      doctorTreeData: [],
      patientTreeData: [],
      defaultProps: {
        children: "children",
        label: "menuName",
      },
      addGrouping: {
        show: false,
        status: 0,
        groupName: "",
        medicalRecordRequired: "",
        appletMenuInfosP: [],
        groupList: [],
      },
      tableData: [],
      tableDisable: false,
      GroupingId:'',
      delGrouping: {
        show: false,
        groupId: "",
        groupList: [],
        groupName: ""
      },
      withdraw: {
        leaderList: [],
        groupId: "",
        show: false,
      },
      ChangePerson: {
        leaderList: [],
        groupId: "",
        show: false,
      },
      deactivate: {
        show: false,
        groupId: "",
        groupName: "",
      },
      groupCode: {
        show: false,
        image: "",
        title: "",
      },
      addLoading: false,
    };
  },
  computed: {
    DeactivateDisabled(){
      return this.tableData.length==1
    },
    doctorID() {
      return this.$route.query.id;
    },
    groupNames() {
      return function (e) {
        return (e || []).map(item => item.docName).join("，");
      }
    },
    groupMenuNames() {
      return function (e) {
        return (this.patientTreeData || []).filter(item => e.includes(item.appletMenuId)).map(item => item.menuName).join("，");
      }
    },
  },
  async created() {
    await this.getTree();
    let id = this.$route.query.id;
    if (id) {
      this.get_details(id);
      await this.getList(id);
    }else {
      const obj = {
        groupId: '0',
        name: "普通患者",
        leaderId: '0',
        type: 0, // 默认分组 0 默认 1 普通
        status: 0, // 启用停用 0 启用 1 停用
        isLeader: 1, // 是否负责人 0 否 1 是
        medicalRecordRequired: 0, // 是否必填就医档案 0 非必填 1 必填
        createTime: "",
        updateTime: "",
        leaderName: "",
        groupList: [],
        groupMenuIds: (this.patientTreeData || []).map(item => item.appletMenuId),
        qrcode: ""
      }
      this.tableDisable = true;
      this.tableData = [obj]
    }
  },
  mounted() {},
  methods: {
    async getList(docId) {
      try {
        this.tableData = [];
        const res = await this.$get("group/list",{
          docId
        });
        if (!res) return false;
        const { data } = res;
        console.log(`分组列表`, res);
        this.tableDisable = false;
        this.tableData = data;
        this.tableData.forEach((item)=>{
          item.DeactivateDisabled=false
        })
       let arr= this.tableData.filter(item=>item.status==0)
       console.log(arr,`arr...`);

        if(arr.length==1){
          arr[0].DeactivateDisabled=true

        }


        this.get_details(docId);
      }catch (e) {
        console.error(e);
      }
    },
    // 入组二维码
    QRgroup(e){
      console.log(`入组二维码`, e);
      this.groupCode.title = e.name;
      this.groupCode.image = e.qrcode;
      this.groupCode.show = true;
    },
    // 启用
    async Enable(e){
      try{
        console.log(e);
        const res = await this.$post("group/toggleStatus", {
          docId: this.doctorID,
          groupId: e.groupId,
          status: 0,
        })
        if (!res) return false;
        // eslint-disable-next-line no-unused-vars
        const { data } = res;
        await this.getList(this.doctorID);
      }catch (e) {
        console.error(e);
      }
    },
    // 停用
    DeactivateHandler(e){
      // console.log(this.tableData);
      // let arr=this.tableData.filter(item=>item.status==0)
      // console.log(arr);
      // if(arr.length==1) return false

      this.deactivate.groupId = e.groupId;
      this.deactivate.groupName = e.name;
      this.deactivate.show = true;
    },
    // 编辑
    edit(e){
      console.log(e);
      this.GroupingId = e.groupId;
      this.addGrouping.groupName = e.name;
      this.addGrouping.status = e.status;
      this.addGrouping.medicalRecordRequired = e.medicalRecordRequired;
      this.addGrouping.appletMenuInfosP = e.groupMenuIds;
      this.addGrouping.groupList = e.groupList;
      this.addGrouping.show = true;
    },
    // 更换负责人
    ChangePersonClick(e){
      this.ChangePerson.leaderList = e.groupList || [];
      this.ChangePerson.groupId = e.groupId;
      this.ChangePerson.show = true;
    },
    // 退组
    withdrawClick(e){

      this.withdraw.leaderList = [...e.groupList,{
        docId: e.leaderId,
        docName: e.leaderName,
      }].filter(item => item.docId !== this.doctorID);
      console.log(this.withdraw.leaderList);

      this.withdraw.groupId = e.groupId;
      this.withdraw.show = true;
      console.log('oooo....',e);

    },
    // 删除
    delGroupingHandler(e){
      this.delGrouping.groupId = e.groupId;
      this.delGrouping.groupName = e.name;
      this.delGrouping.groupList = (this.tableData || []).filter(item => item.groupId !== e.groupId && item.leaderId === e.leaderId).map(item => {
        return {
          groupId: item.groupId,
          name: item.name,
        }
      })
      this.delGrouping.show = true;
    },
    // 添加
    addGroupingHandler() {
      this.GroupingId = '';
      this.addGrouping.groupName = "";
      this.addGrouping.status = 0;
      this.addGrouping.medicalRecordRequired = 1;
      this.addGrouping.appletMenuInfosP = [];
      this.addGrouping.groupList = [];
      this.addGrouping.show = true;
    },
    nodeClick(node) {
      console.log(node);

      // console.log(this.$refs.patientTreeRef.getCheckedKeys());
      let str = node.appletMenuId;
      let arr = this.$refs.patientTreeRef.getCheckedKeys();
      if (str == "16") {
        if (arr.includes("3")) {
          console.log("包含16");
          this.$refs.patientTreeRef.setChecked(3, false);
          arr.forEach((item, index) => {
            if (item == "3") {
              arr.splice(index, 1);
            }
          });
          console.log(arr);

          this.$refs.patientTreeRef.setCheckedKeys(arr);
        }
      } else if (str == "3") {
        if (arr.includes("16")) {
          console.log("包含3");
          this.$refs.patientTreeRef.setChecked(16, false);
          arr.forEach((item, index) => {
            if (item == "16") {
              arr.splice(index, 1);
            }
          });
          console.log(arr);

          this.$refs.patientTreeRef.setCheckedKeys(arr);
        }
      }
    },
    get_details(id) {
      this.$get(`docmanage/detail/${id}`).then((res) => {
        if (res) {
          console.log(res);
          let data_ = res.data;
          this.$nextTick(() => {
            this.form.id = data_.id;
            this.form.username = data_.docName;
            this.form.phoneNo = data_.phoneNo;
            this.form.idCardNo = data_.idCardNo;
            this.form.gender = data_.gender;
            this.form.affiliatedHospital = data_.affiliatedHospital;
            this.form.checkType = data_.checkType;
            this.form.isOpenAi = data_.isOpenAi;
            let appletMenuInfosD = (
              data_.appletMenuInfo.appletMenuInfosD || []
            ).map((item) => item.appletMenuId);
            /*let appletMenuInfosP = (
              data_.appletMenuInfo.appletMenuInfosP || []
            ).map((item) => item.appletMenuId);*/

            this.$refs.doctorTreeRef.setCheckedKeys(appletMenuInfosD);
            // this.$refs.patientTreeRef.setCheckedKeys(appletMenuInfosP);
          });
        }
      });
    },
    onSubmit() {
      this.form.appletMenuIdsD = this.$refs.doctorTreeRef.getCheckedKeys();
      // this.form.appletMenuIdsP = this.$refs.patientTreeRef.getCheckedKeys();
      console.log(this.form);
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          console.log(this.form);
          this.addLoading = true;
          this.$post("docmanage/save", this.form)
              .then(async (res) => {
                console.log(res);
                if (res) {
                  const { data } = res;
                  this.$message.success("添加成功");
                  // this.go_back();
                  await this.getList(data);
                  await this.$router.replace({
                    query: {
                      id: data // 修改已有参数
                    }
                  })
                }
              })
              .finally(() => {
                this.addLoading = false;
              })
        }
      });
    },
    radioChange(e) {
      console.log(e);
      if (e == 1) {
        this.form.checkType = "0";
      }
    },
    getTree() {
      return new Promise((resolve) => {
        this.$get("am/getappletmenuinfo").then((res) => {
          console.log(res);
          let data = res.data;
          this.doctorTreeData = data.appletMenuInfosD;
          this.patientTreeData = data.appletMenuInfosP;
          resolve();
        });
      });
    },
    idCardNoChange(e) {
      this.$refs.formRef.validateField("idCardNo", (valid) => {
        if (!valid) {
          this.form.gender = IdCard(e, 2);
          this.form.age = IdCard(e, 3);
          this.form.birth = IdCard(e, 1);
        } else {
          this.form.gender = "";
          this.form.age = "";
          this.form.birth = "";
        }
      });
    },
    go_back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  padding: 24px;
  background: #ffffff;
}

.content {
  // width: 45%;

  .el-select {
    width: 100%;
  }
}
.AddGroupBtn {
}
.table-box {
  border: 1px solid #ebeef5;
  border-bottom: none;
  margin-top: 10px;
  .operate-box {
    display: flex;
    justify-content: center;
    gap: 10px;
  }
}
::v-deep .el-table thead {
  color: #606266;
  font-weight: 700;
}
::v-deep .el-table th,
.el-table tr {
  background-color: #dbdbdb;
}
.disable{
  color: #c8c9cc !important;
  cursor: not-allowed;
}
</style>
